import { defa }              from 'defa-object';
import ControlModel          from 'scripts/poppet/control-model';

/**
 * defa.models.WarmupSetting
 * The DEFA WarmupSetting model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	warmup: '/warmUp/warmUp?attrs=',
};

const WarmupSetting = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.warmup + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend( {}, ControlModel.prototype.defaults,
		{
			//Vue elements needs default values
			smartHeatingSetting        : null,
			smartHeatingSettingError   : null,
			
			
			heatingSetting        : null,
			heatingSettingError   : null,
			
		} ),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		if(response) {
			let newModelAttributes = {};
			if(response.smartHeatingSetting){
				this.parseAttribute('smartHeatingSetting', response.smartHeatingSetting, options, newModelAttributes)
			}
			if(response.heatingSetting){
				this.parseAttribute('heatingSetting', response.heatingSetting, options, newModelAttributes)
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'warmupSettings' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON: function() {
		return {smartHeatingSetting : !this.get('alwaysOn') , heatingSetting: this.get('heatingSetting')};
	},
	
	_getDependentModels: function () {
		let self = this;
		let dependentModels = [];
		dependentModels.push(channel.request( 'warmupStates' ).get(self.get('id')));
		return dependentModels;
	},

	getAttributes: function() {
		return 'smartHeatingSetting,heatingSetting';
	},
	
} );

export default WarmupSetting;
